var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg031Exit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28994 19.71C4.47771 19.8993 4.7333 20.0058 4.99994 20.0058C5.26658 20.0058 5.52217 19.8993 5.70994 19.71L11.9999 13.41L18.2899 19.71C18.4777 19.8993 18.7333 20.0058 18.9999 20.0058C19.2666 20.0058 19.5222 19.8993 19.7099 19.71C19.8993 19.5222 20.0057 19.2666 20.0057 19C20.0057 18.7334 19.8993 18.4778 19.7099 18.29L13.4099 12L19.7099 5.71C20.1021 5.31788 20.1021 4.68212 19.7099 4.29C19.3178 3.89788 18.6821 3.89788 18.2899 4.29L11.9999 10.59L5.70994 4.29C5.31782 3.89788 4.68206 3.89788 4.28994 4.29C3.89782 4.68212 3.89782 5.31788 4.28994 5.71L10.5899 12L4.28994 18.29C4.10063 18.4778 3.99414 18.7334 3.99414 19C3.99414 19.2666 4.10063 19.5222 4.28994 19.71Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg031Exit);
export default __webpack_public_path__ + "static/media/031-exit.edcc1796a79c29799923ac564c454e39.svg";
export { ForwardRef as ReactComponent };